import React from 'react';
import { PLANS } from '../../config/settings';

const SubscriptionInfo = ({ subscription }) => {
  const currentPlan =
    PLANS.find((plan) => plan.stripeId === subscription?.stripePriceId) ||
    PLANS[0];

  if (!subscription) return null;

  return (
    <>
      <div className="row">
        <div className="col-sm-6">
          <p className="mb-2 font-size-15">
            <strong>Piano:</strong> {currentPlan.title}
          </p>
          <p className="mb-2 font-size-15">
            <strong>Stato:</strong>
            <span
              className={`badge ml-2 ${
                subscription.status === 'active'
                  ? 'badge-success'
                  : 'badge-warning'
              }`}
              style={{ fontSize: '0.85rem' }}>
              {subscription.status === 'active'
                ? 'Attivo'
                : subscription.status === 'inactive'
                ? 'Inattivo'
                : subscription.status === 'canceled'
                ? 'Annullato'
                : ''}
            </span>
          </p>
        </div>
        <div className="col-sm-6">
          <p className="mb-2 font-size-15">
            <strong>Data Inizio:</strong>{' '}
            {subscription.createdAt
              ? new Date(subscription.createdAt).toLocaleDateString('it-IT')
              : 'N/A'}
          </p>
          <p className="mb-2 font-size-15">
            <strong>Prezzo:</strong>{' '}
            {subscription.hasDiscount ? (
              <>
                <span className="text-primary">
                  {subscription.amount === 0
                    ? 'Gratuito'
                    : `€ ${subscription.discountedPrice}`}
                </span>
                {subscription.discountedPrice > 0 && (
                  <span className="text-muted">
                    {' '}
                    / {currentPlan.periodLabel}
                  </span>
                )}
              </>
            ) : (
              <>
                €{subscription.amount} / {currentPlan.periodLabel}
              </>
            )}
          </p>
          <p className="mb-2 font-size-15">
            <strong>Data di prossimo pagamento:</strong>{' '}
            {subscription.autoRenewalDisabled ? (
              <span className="text-warning">Rinnovo disabilitato</span>
            ) : subscription.nextBillingDate ? (
              new Date(subscription.nextBillingDate).toLocaleDateString('it-IT')
            ) : (
              'N/A'
            )}
          </p>
        </div>
      </div>
      {subscription.hasDiscount && (
        <div className="row mt-3">
          <div className="col-12">
            <div className="alert alert-info">
              <i className="bx bxs-coupon mr-2"></i>
              <strong>
                Codice sconto applicato: {subscription.stripeCouponId}
              </strong>
              {subscription.amount === 0 && (
                <span> Il tuo piano è gratuito.</span>
              )}
              {subscription.autoRenewalDisabled && (
                <span> Il rinnovo automatico è stato disabilitato.</span>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="row mt-4">
        <div className="col-12">
          <p className="text-muted mb-0 lead">{currentPlan.description}</p>
        </div>
      </div>
      {subscription.status === 'canceled' && (
        <div className="alert alert-warning mt-3">
          Il tuo abbonamento è stato annullato. Potrai continuare a utilizzare i
          nostri servizi fino alla data di scadenza:{' '}
          <strong>
            {subscription.endDate
              ? new Date(subscription.endDate).toLocaleDateString('it-IT')
              : 'N/A'}
          </strong>
        </div>
      )}
    </>
  );
};

export default SubscriptionInfo;
